// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"956":"612e4da5","1823":"88d8ec22","8137":"1ae29d39","9027":"8519f46a","9797":"bb255b87"}[chunkId] + ".chunk.css";
};